export const calcWidthInput = (input: HTMLInputElement, elemCalcWidth: HTMLPreElement) => {
  elemCalcWidth.textContent = input.value;
  input.style.width = elemCalcWidth.clientWidth + "px";
};

export const trimSpaceAndComma = (string: string): string => string.replace(/^[\s,]+|[\s,]+$/g, "");
